// initial state
const state = {
  ready: false,
  i18n: {
    errors: undefined,
    components: undefined,
  },
  applications: undefined,
  lastRenderer: undefined,
  userApplication: undefined,
  tracker: {
    i18n: undefined,
  },
  ranchsync: undefined,
  routes: undefined,
};

const actions = {};

const mutations = {
  setI18nErrors(state, i18n) {
    state.i18n.errors = i18n;
  },
  setRoutes(state, routes) {
    state.routes = routes;
  },
  setI18nTracker(state, i18n) {
    state.tracker.i18n = i18n;
  },
  setI18nComponents(state, i18n) {
    state.i18n.components = i18n;
  },
  setApplications(state, applications) {
    state.applications = applications;
  },
  setLastRenderer(state, data) {
    state.lastRenderer = data;
  },
  setUserApplication(state, data) {
    state.userApplication = data;
  },
  setRanchsync(state, ranchsync) {
    state.ranchsync = ranchsync;
  },
  setReady(state, status) {
    state.ready = status;
  },
};

const getters = {
  userApplicationSlug(state) {
    if (state.lastRenderer) {
      return state.lastRenderer.application.slug;
    }
    return state.userApplication;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
